import User from 'modules/reports/models/User'

export default class AuthStore {
  user: User

  setUserData(data: any) {
    this.user = new User().set(data)
  }
}
